const defaultTheme = {
  colors: {
    primary: '#2E2C6F',
    secondary: '#1D38C5',
    third: '#888',
    fourth: '#ddd',
    fifth: '#757575',
    sixth: '#273979',
    seventh: '#7C869C',
    background: '#eee',
    primaryText: '#2E2C6F',
    secondaryText: '#22DAAB',
    thirdText: '#212121',
    fourthText: '#BCBBD1',
    startActive: '#eb4f30',
    red: '#ff424d',
  },
};

export default defaultTheme;
